export interface INegotiateResponse {
    signalRTransportProtocol: signalRTransportProtocol,
    messagePack: boolean
}

export enum signalRTransportProtocol {
    webSocket,
    serverSentEvents
}